export const mediumSpeed = '.3s';
export const slowSpeed = '.7s';
